import * as WebViewActionTypes from './action-types.constants';
import _merge from 'lodash.merge';
import MobileDetect from 'mobile-detect';
// import "./show-more.scss";

const { URLSearchParams, navigator, location} = window;
const md = new MobileDetect(navigator.userAgent);
function getDefaultState() {
    const DEFAULT_STATE = {
        "ready": false,
        "isIframe": window !== parent,
        "isMobile": md.mobile() != null,
        "location": {
            "search": new URLSearchParams(location.search),
            "pathname": document.location.pathname
        },
        "medscape": {
            "imageServer": {
                "host": ""
            }
        },
        "MedscapeTV": window.MedscapeTV
    }
    return DEFAULT_STATE;
}

const WebView = (state = getDefaultState(), action) => {
    let newState = {};

    const { type } = action;

    switch (type) {
        case WebViewActionTypes.READY:
            newState = _merge({}, action.props, {
                "ready": true,
                "medscape": action.medscape,
                "tracking": action.tracking
            });
            break;
        case WebViewActionTypes.UPDATE_LOCATION:
            newState = {
                "location": {
                    "search": action.location.search,
                    "pathname": action.location.pathname
                }
            }
        default:
            newState = state;
    }
    if (newState !== state) {
        newState = _merge(getDefaultState(), state, newState);
    }
    //console.log("[MediaPlayer Reducers] newState",newState);

    return newState;
}

export default WebView;